export enum QuestionTypeEnum {
  SIMPLE = 'simple',
  COMPLEX_WITH_INPUT = 'complex_with_input',
  COMPLEX_WITH_SUBS = 'complex_with_subs',
  EXCLUSIVE_SUBS = 'exclusive_subs'
}
